import React, { useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { TagProvider } from './contexts/TagContext';
import { ErrorBoundary } from 'react-error-boundary';
import { siteConfig } from './config/site';
import LockdownPage from './components/LockdownPage';
import NotFound from './components/NotFound';
import Header from './components/Header';
import Footer from './components/Footer';
import Sidebar from './components/subcomponents/Sidebar';
import './App.css';
import './components/Layout.css';

function App({ components = [] }) {
  const [opensidebar, setOpenSidebar] = useState(false);
  const [componentsToShow] = useState(components);
  const toggleSidebar = () => setOpenSidebar(!opensidebar);

  const renderComponent = (component) => {
    const Component = component.component;
    return (
      <Route
        key={component.path}
        path={component.path}
        element={<Component key={component.name} />}
      />
    );
  };

  return (
    <ThemeProvider>
      <TagProvider>
        <ErrorBoundary>
          {siteConfig.lockdownMode ? (
            <LockdownPage />
          ) : (
            <div className="app">
              <Sidebar components={components} open={opensidebar} toggleSidebar={toggleSidebar} />
              <div className={`main-content ${opensidebar ? 'sidebar-open' : ''}`}>
                <Header componentsToShow={componentsToShow} />
                <main>
                  <Routes>
                    {/* Home route: Render all components */}
                    <Route
                      path="/"
                      element={
                        <>
                          {components.map((component) => {
                            const Component = component.component;
                            return <Component key={component.name} />;
                          })}
                        </>
                      }
                    />
                    {/* Other routes */}
                    {components.map(renderComponent)}
                    {/* Fallback route */}
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </main>
                <Footer />
              </div>
            </div>
          )}
        </ErrorBoundary>
      </TagProvider>
    </ThemeProvider>
  );
}

export default App;